import { IPayloadProps } from "../../../../@types/Onboarding/IPayload";

import { IProfile } from "../../../../@types/app/IProfile";
import Constants from "../../../../constants/Index";

export type ShapefileUser = IProfile & { isNewForShapefile?: boolean };
export type ShapefileNewUser = Pick<IProfile, "uuid" | "name" | "phone" | "profile_id"> & { password: string };

// Payload used by POST /shapefile.
export type ShapefileDraft = Pick<IPayloadProps, "farms" | "areas" | "micro_areas"> & { users: ShapefileNewUser[] };

export function buildShapefileDraft(payload: IPayloadProps): ShapefileDraft {
  const referencedUsers = new Set((payload.areas || []).map(area => {
    const manager = area.manager_user_id;
    return String(manager && typeof manager === "object" ? manager.value : manager);
  }));
  return {
    users: (payload.users || []).filter((user: ShapefileUser) => user.isNewForShapefile && referencedUsers.has(user.uuid))
      .map(({ uuid, name, phone, profile_id }) => ({ uuid, name, phone, profile_id, password: Constants.DEFAULT_PASSWORD })),
    farms: payload.farms || [],
    areas: payload.areas || [],
    micro_areas: (payload.micro_areas || []).map(({ uuid, area_id, initials, acreage, map_coords }) => ({
      uuid,
      area_id,
      initials,
      acreage,
      map_coords,
    })),
  };
}
